import React, { useCallback, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
// import { Input } from 'antd';
import classNames from 'classnames';
import { createStructuredSelector } from 'reselect';
import {
  // updatePropertiesOnConjointOrMaxDiff,
  updateQuestionnaire,
} from 'containers/QuestionnairePage/actions';
import QuestionComments from 'containers/QuestionnairePage/GenericQuestion/QuestionComments';
import questionnaireMessages from 'containers/QuestionnairePage/messages';

import { QUESTION_PROMPT_MAX_LENGTH } from 'containers/QuestionnairePage/constants';

import FormattedInput from 'components/FormattedInput/Loadable';

import PfAlert from 'components/PfAlert';
import { TYPE_DANGER } from 'components/PfAlert/constants';

import { useDebounce, useDidUpdate } from 'utils/hooks';
import { getCleanQuestionData } from 'utils/questionHelpers';

import { compose } from 'redux';
import messages from './messages';
import { makeSelectActiveQuestionId } from '../../selectors';

function QuestionBlock({
  question,
  // groupRefId,
  // conceptsLabel,
  canEditPrompt,
  intl,
  onResolveComment,
  focus,
  activeQuestionId,
}) {
  const {
    label,
    prompt = '',
    htmlPrompt = '',
    errors = {},
    comments,
    pristineValues,
  } = question;

  const [questionValues, setQuestionValues] = useState({
    prompt,
    htmlPrompt,
  });
  // const [label, setLabel] = useState(conceptsLabel || '');
  const dispatch = useDispatch();

  const onUpdatePrompt = useCallback(
    (payload) => setQuestionValues(payload),
    [],
  );

  const [debouncedQuestionValues] = useDebounce(questionValues, 200);
  useDidUpdate(() => {
    dispatch(
      updateQuestionnaire({
        question: getCleanQuestionData({
          ...question,
          pristineValues: {
            ...pristineValues,
            isPristinePrompt: false,
          },
          ...debouncedQuestionValues,
        }),
      }),
    );
  }, [debouncedQuestionValues]);

  /* const onUpdateLabel = useCallback((e) => {
    setLabel(e.target.value);
  }, []);

  const [debouncedLabel] = useDebounce(label, 300);
  useDidUpdate(() => {
    dispatch(
      updatePropertiesOnConjointOrMaxDiff({
        refId: groupRefId,
        properties: {
          conceptsLabel: debouncedLabel,
        },
      }),
    );
  }, [debouncedLabel]); */

  return (
    <div className="background-grey-1 border-radius-level-1 padding-horizontal-lg padding-vertical-md">
      <QuestionComments
        label={label}
        comments={comments}
        onResolveComment={onResolveComment}
      />

      <p className="text-weight-bold text-size-secondary color-grey-10 margin-btm-xxs">
        {label} <FormattedMessage {...messages.instruction} />
      </p>

      <FormattedInput
        spellCheck={false}
        className={classNames(
          'conjoint-editor',
          'ant-input-shadow-none',
          'text-size-secondary',
          'pf-input-no-shadow',
          'padding-horizontal-xs',
          'border-none',
          'outline-none',
          'shadow-none',
          'border-radius-level-1',
          'cursor-text',
          'color-grey-10',
          'color-grey-9-placeholder',
          'background-grey-4',
          'flex',
          'flex-items-center',
        )}
        readOnly={!canEditPrompt}
        placeholder={intl.formatMessage(messages.questionPlaceholder)}
        defaultHtml={questionValues.htmlPrompt}
        defaultValue={questionValues.prompt}
        onChange={onUpdatePrompt}
        style={{ top: -1 }}
        editorStyle={{
          minHeight: 30,
          maxHeight: 300,
          overflowY: 'auto',
        }}
        autoFocus={focus}
        refId={question.refId}
        activeQuestionId={activeQuestionId}
        currentNodeRefId={question.refId}
      />

      {!pristineValues.isPristinePrompt && errors.missingPrompt && (
        <PfAlert
          className="padding-left-none"
          noBackground
          title={
            <FormattedMessage {...questionnaireMessages.errors.missingPrompt} />
          }
          type={TYPE_DANGER}
        />
      )}

      {!pristineValues.isPristinePrompt && errors.questionTooLong && (
        <PfAlert
          className="padding-left-none"
          noBackground
          title={
            <FormattedMessage
              {...questionnaireMessages.errors.questionTooLong}
              values={{ maxLength: QUESTION_PROMPT_MAX_LENGTH }}
            />
          }
          type={TYPE_DANGER}
        />
      )}

      {/* <p className="text-weight-bold text-size-secondary color-grey-10 margin-btm-xxs margin-top-sm">
        <FormattedMessage {...messages.conceptLabel} />
      </p>

      <Input
        spellCheck={false}
        readOnly={!canEditPrompt}
        value={label}
        onChange={onUpdateLabel}
        maxLength={CONJOINT_TEXT_MAX_LENGTH}
        style={{ height: 30 }}
        className={classNames(
          'ant-input-shadow-none',
          'text-size-secondary',
          'pf-input-no-shadow',
          'padding-horizontal-xs',
          'border-none',
          'outline-none',
          'shadow-none',
          'border-radius-level-1',
          'cursor-text',
          'color-grey-10',
          'color-grey-9-placeholder',
          'background-grey-4',
        )}
      /> */}
    </div>
  );
}

QuestionBlock.propTypes = {
  question: PropTypes.object,
  groupRefId: PropTypes.string,
  conceptsLabel: PropTypes.string,
  canEditPrompt: PropTypes.bool,
  onResolveComment: PropTypes.func,
  focus: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  activeQuestionId: makeSelectActiveQuestionId,
});

const withConnect = connect(mapStateToProps);

export const QuestionBlockWithIntl = injectIntl(QuestionBlock);

export default compose(withConnect)(QuestionBlockWithIntl);
